// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"221":"779fcf25a0d4852c8a1b","489":"3fb9aaa1bb5914b3c097","524":"1a60671b262456ef694f"}[chunkId] + ".css";
};